import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { ContentHeaderKey } from "src/app/constants/content-header";

import { AgentPaths } from "src/app/constants/routes";
import { ReportWizardPanel } from "src/app/constants/wizard-panels";
import { NextPanel } from "src/app/models/next-panel";
import { ParameterPaylod, ReportDropDownList, ReportSummaryPayload, ReportTemplateModel, ReportTemplatePayload, ReportWizardCompanyPayload, ReportWizardDetail, ReportWizardDetailPayload, ReportWizardIntializePayload, ReportWizardParameters } from "src/app/models/reports";
import { ReportsService } from "src/app/services/reports.service";

@Component({
    selector: 'mwp-reports-wizard',
    templateUrl: './report-wizard.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReportWizardComponent implements OnInit {

    public reportWizardPanel = ReportWizardPanel;
    public reportID: number;
    public wizardPanel: string;
    public reports: ReportDropDownList;
    public reportWizardParameters: ReportWizardParameters;
    public reportWizardDetail: ReportWizardDetail;
    public reportSummaryPayload: ReportSummaryPayload;
    public templates: ReportTemplateModel[];
    public apiUrl = ContentHeaderKey.CounselorReports;

    constructor(
        private router: Router,
        private reportsService: ReportsService,
    ) {
    }

    ngOnInit(): void {
        this.loadReports();
    }

    private loadReports(): void {
        this.reportsService.getReports().subscribe((response: ReportDropDownList) => {
            this.wizardPanel = ReportWizardPanel.initialize;
            this.reports = response;
        });
    }

    private clearParameters() {
        this.reportWizardParameters = null;
        this.reportWizardDetail = null;
        this.reportSummaryPayload = null;
    }

    public reset(): void {
        this.wizardPanel = ReportWizardPanel.initialize;
        this.reportID = null;
        this.clearParameters();
    }

    public reload(): void {
        this.reportID = null;
        this.clearParameters();
        this.loadReports();
    }

    public submitPanel(event: any): void {
        switch (this.wizardPanel) {
            case ReportWizardPanel.initialize:
                this.reportID = event as number;
                const l_ReportWizardIntializePayload: ReportWizardIntializePayload = {
                    reportID: this.reportID,
                };

                this.reportsService.initialize(l_ReportWizardIntializePayload).subscribe((response: NextPanel) => {
                    this.loadNextPanel(response.nextPanel.value);
                });
                break;

            case ReportWizardPanel.company:
                const l_ReportWizardCompanyPayload: ReportWizardCompanyPayload = {
                    companyID: event as number,
                };

                this.reportsService.setCompany(l_ReportWizardCompanyPayload).subscribe((response: NextPanel) => {
                    this.loadNextPanel(response.nextPanel.value);
                });
                break;

            case ReportWizardPanel.templates:
                const l_ReportTemplatePayload = event as ReportTemplatePayload;
                this.reportsService.setTemplate(l_ReportTemplatePayload).subscribe((response: NextPanel) => {
                    this.loadNextPanel(response.nextPanel.value);
                });
                break;

            case ReportWizardPanel.parameters:
                const l_ParameterPaylod = event as ParameterPaylod;
                this.reportsService.setParameters(l_ParameterPaylod).subscribe((response: NextPanel) => {
                    this.loadNextPanel(response.nextPanel.value);
                });
                break;

            case ReportWizardPanel.detail:
                const l_ReportWizardDetailPayload = event as ReportWizardDetailPayload;
                this.reportsService.setDetail(l_ReportWizardDetailPayload).subscribe((response: NextPanel) => {
                    this.loadNextPanel(response.nextPanel.value);
                });
                break;

            case ReportWizardPanel.summary:
                this.reportsService.proccessReport().subscribe((response: NextPanel) => {
                    if (response.nextPanel.value == ReportWizardPanel.finalize) {
                        this.router.navigateByUrl(AgentPaths.ReportsToday);
                    } else {
                        this.loadNextPanel(response.nextPanel.value);
                    }
                });
                break;
        }
    }

    private loadNextPanel(panel: string): void {
        switch (panel) {
            case ReportWizardPanel.templates:
                this.reportsService.getTemplates().subscribe((response: ReportTemplateModel[]) => {
                    this.templates = response;
                    this.wizardPanel = panel;
                });
                break;

            case ReportWizardPanel.parameters:
                this.reportsService.getParameters().subscribe((response: ReportWizardParameters) => {
                    this.reportWizardParameters = response;
                    this.wizardPanel = panel;
                });
                break;

            case ReportWizardPanel.detail:
                this.reportsService.getDetail().subscribe((response: ReportWizardDetail) => {
                    this.reportWizardDetail = response;
                    this.wizardPanel = panel;
                });
                break;

            case ReportWizardPanel.summary:
                this.reportsService.getSummary().subscribe((response: any) => {
                    this.reportSummaryPayload = response;
                    this.wizardPanel = panel;
                });
                break;

            case ReportWizardPanel.initialize:
            case ReportWizardPanel.company:
            default:
                this.wizardPanel = panel;
                break;
        }
    }

}